import React from 'react';
import { Insights as InsightsComponent } from '../components/Insights';

const Insights: React.FC = () => {
return <InsightsComponent />;
};

export default Insights; 